/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("dashboard.title")}
      </Typography>
      <hr />

      {/* Savings */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.savings.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.savings.body")}
        </Box>
      </Typography>

      {/* Self-Sufficiency */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.self_sufficiency.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.self_sufficiency.body")}
        </Box>
      </Typography>

      {/* Injected Self-Consumed */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.injected_self_consumed.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.injected_self_consumed.body")}
        </Box>
      </Typography>

      {/* Carbon Reduction */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.carbon_reduction.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.carbon_reduction.body")}
        </Box>
      </Typography>

      {/* Top 3 */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.top3.title")}
      </Typography>

      <Typography
        variant="h4"
        mt={2}
        ml={4}
        sx={{
          fontWeight: "600",
          color: (theme) => (theme.palette.mode === "dark" ? "rgba(255,255,255,0.9)" : "inherit"),
        }}
      >
        {t("dashboard.top3.savings.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.top3.savings.body")}
        </Box>
      </Typography>

      <Typography
        variant="h4"
        mt={4}
        ml={4}
        sx={{
          fontWeight: "600",
          color: (theme) => (theme.palette.mode === "dark" ? "rgba(255,255,255,0.9)" : "inherit"),
        }}
      >
        {t("dashboard.top3.net_consumption.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.top3.net_consumption.body")}
        </Box>
      </Typography>

      <Typography
        variant="h4"
        mt={4}
        ml={4}
        sx={{
          fontWeight: "600",
          color: (theme) => (theme.palette.mode === "dark" ? "rgba(255,255,255,0.9)" : "inherit"),
        }}
      >
        {t("dashboard.top3.carbon_reduction.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.top3.carbon_reduction.body")}
        </Box>
      </Typography>

      {/* Savings per Day */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.savings_per_day.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.savings_per_day.body")}
        </Box>
      </Typography>

      {/* AC Energy */}
      <Typography
        variant="h3"
        mt={4}
        ml={2}
        sx={{
          fontWeight: "bold",
          color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "inherit"),
        }}
      >
        {t("dashboard.ac_energy.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dashboard.ac_energy.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
